import { 
    endOfMonth, 
    endOfYear, 
    format, 
    startOfMonth, 
    startOfYear, 
    subMonths, 
    subYears 
} from "date-fns";

export const getRangeForType = (nextType) => {
    const today = new Date();
    const todayIso = format(today, "yyyy-MM-dd");

    if (nextType === "this-year-to-date") {
      const lastFullMonth = subMonths(today, 1);
      return { 
        start: format(startOfYear(today), "yyyy-MM-dd"), 
        end: format(endOfMonth(lastFullMonth), "yyyy-MM-dd") 
      };
    }

    if (nextType === "last-month") {
      const lastMonth = subMonths(today, 1);
      return {
        start: format(startOfMonth(lastMonth), "yyyy-MM-dd"),
        end: format(endOfMonth(lastMonth), "yyyy-MM-dd"),
      };
    }

    if (nextType === "last-quarter") {
      const year = today.getFullYear();
      const monthIndex = today.getMonth(); // 0-11
      const currentQuarter = Math.floor(monthIndex / 3) + 1; // 1-4
      const lastQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
      const lastQuarterYear = currentQuarter === 1 ? year - 1 : year;
      const startMonthIndex = (lastQuarter - 1) * 3;
      const quarterStart = new Date(lastQuarterYear, startMonthIndex, 1);
      const quarterEnd = endOfMonth(new Date(lastQuarterYear, startMonthIndex + 2, 1));
      return { start: format(quarterStart, "yyyy-MM-dd"), end: format(quarterEnd, "yyyy-MM-dd") };
    }

    if (nextType === "last-year") {
      const lastYear = subYears(today, 1);
      return { start: format(startOfYear(lastYear), "yyyy-MM-dd"), end: format(endOfYear(lastYear), "yyyy-MM-dd") };
    }

    return null;
};

/** Latest selectable calendar day when capping pickers to "through end of this year" (`yyyy-MM-dd`). */
export const getEndOfCurrentCalendarYearYmd = () =>
    format(endOfYear(new Date()), "yyyy-MM-dd");